import { AppointmentTypeDto } from "core/gateways/practice/location.dtos";
import { LocationDto } from "core/types";

/**Utility function to sort objects alphabetically by key */
export const alphabeticalSortPredicate =
  <T extends object>(key: keyof T) =>
  (a: T, b: T) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  };

// Helper Functions
export const checkProviderBaseInterval = (
  appointmentType: AppointmentTypeDto,
  baseInterval: number
) => {
  // React can re-render the page with a undefined value before we navigate off to the provider appointment type's page.
  if (appointmentType === undefined) {
    return false;
  }

  const isNewDurationBaseIntervalWrong =
    appointmentType.newPatientDuration! % baseInterval !== 0 &&
    appointmentType.isAvailableNewPatients;

  const isExistingDurationBaseIntervalWrong =
    (appointmentType.minuteDuration! * 60) % baseInterval !== 0 &&
    appointmentType.isAvailableExistingPatients;

  return (
    (isNewDurationBaseIntervalWrong || isExistingDurationBaseIntervalWrong) &&
    appointmentType.customised
  );
};

export const checkLocationBaseInterval = (
  appointmentType: AppointmentTypeDto,
  baseInterval: number
) => {
  return (
    appointmentType.newPatientDuration &&
    appointmentType.newPatientDuration % baseInterval !== 0 &&
    appointmentType.isAvailableNewPatients === true
  );
};

export const isKeywordPresent = (inputs: string[], keyword: string) => {
  const loweredCaseInput = inputs.map(i => i.toLocaleLowerCase());
  return !!loweredCaseInput.find(lcInp =>
    lcInp.includes(keyword.toLocaleLowerCase())
  );
};

export const getSortedLocations = (locations: LocationDto[]) => {
  const sortedLocations = [...locations].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const onlineLocations: LocationDto[] = [];

  const offlineLocations: LocationDto[] = [];

  sortedLocations.forEach(location => {
    if (location.onlineBookingsEnabled) {
      onlineLocations.push({ ...location });
    } else {
      offlineLocations.push({ ...location });
    }
  });
  return [...onlineLocations, ...offlineLocations];
};

export const getFormattedPhoneNumber = (phoneNumber?: string) =>
  phoneNumber?.replace(/\D*(\d{2})\D*(\d{4})\D*(\d{4})\D*/, "$1 $2 $3");
